import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  fetchAIGeneratedBlog,
  fetchBCAScheduler,
  fetchBCASchedulerBroadcastLogs,
  fetchBlogCategories,
  fetchBlogs,
  fetchBroadcastListings,
  fetchBroadcastLogs,
  fetchBroadcastTemplates,
  fetchBroadcastVariables,
  fetchBroadcastWPTemplates,
  fetchParentBlogCategories,
  fetchSendyLists,
} from "./blogApiS";

export const fetchParentBlogCategoriesData = createAsyncThunk(
  "blog/fetchParentBlogCategoriesData",
  async (payload, { getState }) => {
    const { filters, token } = payload;
    const response = await fetchParentBlogCategories(filters, token);
    return response;
  }
);

export const fetchBlogCategoriesData = createAsyncThunk(
  "blog/fetchBlogCategoriesData",
  async (payload, { getState }) => {
    const { filters, token } = payload;
    const response = await fetchBlogCategories(filters, token);
    return response;
  }
);

export const fetchBlogsData = createAsyncThunk(
  "blog/fetchBlogsData",
  async (payload, { getState }) => {
    const { filters, token } = payload;
    const response = await fetchBlogs(filters, token);
    return response;
  }
);

export const fetchAIGeneratedBlogsData = createAsyncThunk(
  "blog/fetchAIGeneratedBlogsData",
  async (payload, { getState }) => {
    const { filters, token } = payload;
    const response = await fetchAIGeneratedBlog(filters, token);
    return response;
  }
);

export const fetchBroadcastTemplatesData = createAsyncThunk(
  "blog/fetchBroadcastTemplatesData",
  async (payload, { getState }) => {
    const { filters, token } = payload;
    const response = await fetchBroadcastTemplates(filters, token);
    return response;
  }
);

export const fetchBroadcastWPTemplatesData = createAsyncThunk(
  "blog/fetchBroadcastWPTemplatesData",
  async (payload, { getState }) => {
    const { filters, token } = payload;
    const response = await fetchBroadcastWPTemplates(filters, token);
    return response;
  }
);

export const fetchBroadcastVariablesData = createAsyncThunk(
  "blog/fetchBroadcastVariablesData",
  async (payload, { getState }) => {
    const { filters, token } = payload;
    const response = await fetchBroadcastVariables(filters, token);
    return response;
  }
);

export const fetchSendyListsData = createAsyncThunk(
  "blog/fetchSendyListsData",
  async (payload, { getState }) => {
    const { filters, token } = payload;
    const response = await fetchSendyLists(filters, token);
    return response;
  }
);

export const fetchBroadcastListingsData = createAsyncThunk(
  "blog/fetchBroadcastListingsData",
  async (payload, { getState }) => {
    const { filters, token } = payload;
    const response = await fetchBroadcastListings(filters, token);
    return response;
  }
);

export const fetchBroadcastLogsData = createAsyncThunk(
  "blog/fetchBroadcastLogsData",
  async (payload, { getState }) => {
    const { filters, token } = payload;
    const response = await fetchBroadcastLogs(filters, token);
    return response;
  }
);

export const fetchBCASchedulerData = createAsyncThunk(
  "blog/fetchBCASchedulerData",
  async (payload, { getState }) => {
    const { filters, token } = payload;
    const response = await fetchBCAScheduler(filters, token);
    return response;
  }
);

export const fetchBCASchedulerBroadcastLogsData = createAsyncThunk(
  "blog/fetchBCASchedulerBroadcastLogsData",
  async (payload, { getState }) => {
    const { filters, token } = payload;
    const response = await fetchBCASchedulerBroadcastLogs(filters, token);
    return response;
  }
);

const blogSlice = createSlice({
  name: "blog",
  initialState: {
    parentBlogCategories: null,
    parentBlogCategoriesLoading: false,
    parentBlogCategoriesError: null,

    blogCategories: null,
    blogCategoriesLoading: false,
    blogCategoriesError: null,

    blogs: null,
    blogsLoading: false,
    blogsError: null,

    aiGeneratedBlog: null,
    aiGeneratedBlogLoading: false,
    aiGeneratedBlogError: null,

    broadcastTemplates: null,
    broadcastTemplatesLoading: false,
    broadcastTemplatesError: null,

    broadcastVariables: null,
    broadcastVariablesLoading: false,
    broadcastVariablesError: null,

    broadcastWPTemplates: null,
    broadcastWPTemplatesLoading: false,
    broadcastWPTemplatesError: null,

    sendyLists: null,
    sendyListsLoading: false,
    sendyListsError: null,

    broadcastListings: null,
    broadcastListingsLoading: false,
    broadcastListingsError: null,

    broadcastLogs: null,
    broadcastLogsLoading: false,
    broadcastLogsError: null,

    bcaScheduler: null,
    bcaSchedulerLoading: false,
    bcaSchedulerError: null,

    bcaSchedulerBroadcastLogs: null,
    bcaSchedulerBroadcastLogsLoading: false,
    bcaSchedulerBroadcastLogsError: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchParentBlogCategoriesData.pending, (state) => {
        state.parentBlogCategoriesLoading = true;
      })
      .addCase(fetchParentBlogCategoriesData.fulfilled, (state, action) => {
        state.parentBlogCategoriesLoading = false;
        state.parentBlogCategories = action.payload;
      })
      .addCase(fetchParentBlogCategoriesData.rejected, (state, action) => {
        state.parentBlogCategoriesLoading = false;
        state.parentBlogCategoriesError = action.error.message;
      })

      .addCase(fetchBlogCategoriesData.pending, (state) => {
        state.blogCategoriesLoading = true;
      })
      .addCase(fetchBlogCategoriesData.fulfilled, (state, action) => {
        state.blogCategoriesLoading = false;
        state.blogCategories = action.payload;
      })
      .addCase(fetchBlogCategoriesData.rejected, (state, action) => {
        state.blogCategoriesLoading = false;
        state.blogCategoriesError = action.error.message;
      })

      .addCase(fetchBlogsData.pending, (state) => {
        state.blogsLoading = true;
      })
      .addCase(fetchBlogsData.fulfilled, (state, action) => {
        state.blogsLoading = false;
        state.blogs = action.payload;
      })
      .addCase(fetchBlogsData.rejected, (state, action) => {
        state.blogsLoading = false;
        state.blogsError = action.error.message;
      })

      .addCase(fetchAIGeneratedBlogsData.pending, (state) => {
        state.aiGeneratedBlogLoading = true;
      })
      .addCase(fetchAIGeneratedBlogsData.fulfilled, (state, action) => {
        state.aiGeneratedBlogLoading = false;
        state.aiGeneratedBlog = action.payload;
      })
      .addCase(fetchAIGeneratedBlogsData.rejected, (state, action) => {
        state.aiGeneratedBlogLoading = false;
        state.aiGeneratedBlogError = action.error.message;
      })

      .addCase(fetchBroadcastTemplatesData.pending, (state) => {
        state.broadcastTemplatesLoading = true;
      })
      .addCase(fetchBroadcastTemplatesData.fulfilled, (state, action) => {
        state.broadcastTemplatesLoading = false;
        state.broadcastTemplates = action.payload;
      })
      .addCase(fetchBroadcastTemplatesData.rejected, (state, action) => {
        state.broadcastTemplatesLoading = false;
        state.broadcastTemplatesError = action.error.message;
      })

      .addCase(fetchBroadcastVariablesData.pending, (state) => {
        state.broadcastVariablesLoading = true;
      })
      .addCase(fetchBroadcastVariablesData.fulfilled, (state, action) => {
        state.broadcastVariablesLoading = false;
        state.broadcastVariables = action.payload;
      })
      .addCase(fetchBroadcastVariablesData.rejected, (state, action) => {
        state.broadcastVariablesLoading = false;
        state.broadcastVariablesError = action.error.message;
      })

      .addCase(fetchBroadcastWPTemplatesData.pending, (state) => {
        state.broadcastWPTemplatesLoading = true;
      })
      .addCase(fetchBroadcastWPTemplatesData.fulfilled, (state, action) => {
        state.broadcastWPTemplatesLoading = false;
        state.broadcastWPTemplates = action.payload;
      })
      .addCase(fetchBroadcastWPTemplatesData.rejected, (state, action) => {
        state.broadcastWPTemplatesLoading = false;
        state.broadcastWPTemplatesError = action.error.message;
      })

      .addCase(fetchSendyListsData.pending, (state) => {
        state.sendyListsLoading = true;
      })
      .addCase(fetchSendyListsData.fulfilled, (state, action) => {
        state.sendyListsLoading = false;
        state.sendyLists = action.payload;
      })
      .addCase(fetchSendyListsData.rejected, (state, action) => {
        state.sendyListsLoading = false;
        state.sendyListsError = action.error.message;
      })

      .addCase(fetchBroadcastListingsData.pending, (state) => {
        state.broadcastListingsLoading = true;
      })
      .addCase(fetchBroadcastListingsData.fulfilled, (state, action) => {
        state.broadcastListingsLoading = false;
        state.broadcastListings = action.payload;
      })
      .addCase(fetchBroadcastListingsData.rejected, (state, action) => {
        state.broadcastListingsLoading = false;
        state.broadcastListingsError = action.error.message;
      })

      .addCase(fetchBroadcastLogsData.pending, (state) => {
        state.broadcastLogsLoading = true;
        state.broadcastLogsError = null;
      })
      .addCase(fetchBroadcastLogsData.fulfilled, (state, action) => {
        state.broadcastLogsLoading = false;
        state.broadcastLogs = action.payload;
      })
      .addCase(fetchBroadcastLogsData.rejected, (state, action) => {
        state.broadcastLogsLoading = false;
        state.broadcastLogsError = action.error.message;
      })

      .addCase(fetchBCASchedulerData.pending, (state) => {
        state.bcaSchedulerLoading = true;
      })
      .addCase(fetchBCASchedulerData.fulfilled, (state, action) => {
        state.bcaSchedulerLoading = false;
        state.bcaScheduler = action.payload;
      })
      .addCase(fetchBCASchedulerData.rejected, (state, action) => {
        state.bcaSchedulerLoading = false;
        state.bcaSchedulerError = action.error.message;
      })

      .addCase(fetchBCASchedulerBroadcastLogsData.pending, (state) => {
        state.bcaSchedulerBroadcastLogsLoading = true;
      })
      .addCase(
        fetchBCASchedulerBroadcastLogsData.fulfilled,
        (state, action) => {
          state.bcaSchedulerBroadcastLogsLoading = false;
          state.bcaSchedulerBroadcastLogs = action.payload;
        }
      )
      .addCase(fetchBCASchedulerBroadcastLogsData.rejected, (state, action) => {
        state.bcaSchedulerBroadcastLogsLoading = false;
        state.bcaSchedulerBroadcastLogsError = action.error.message;
      });
  },
});

export default blogSlice.reducer;
